import axios from 'axios';
import qs from 'qs';
import { IStoreLocatorAutocomplete } from '../models/IStoreLocatorAutocomplete';

const storeLocatorAutocomplete = async ({
  endpoint,
  countryCode,
  searchTerm,
}: {
  endpoint: string;
  countryCode: string;
  searchTerm: string;
}): Promise<IStoreLocatorAutocomplete[]> => {
  const query = qs.stringify({
    countryCode,
    input: searchTerm,
  });

  const { data } = await axios.get<{
    predictions: IStoreLocatorAutocomplete[];
  } | null>(`${endpoint}?${query}`);

  return data?.predictions || [];
};

export default storeLocatorAutocomplete;
